<template>
  <el-select
    v-model="locale"
    @change="handleLocaleChange"
    style="width: 120px"
  >
    <el-option
      v-for="item in languages"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script setup>
const { locale } = useI18n()

const languages = [
  { label: '简体中文', value: 'zh-CN' },
  { label: 'English', value: 'en' }
]

const handleLocaleChange = (value) => {
  // 更新 URL 中的 locale 参数
  const url = new URL(window.location.href)
  url.searchParams.set('locale', value)
  window.location.href = url.toString()
}
</script> 